/* eslint-disable */
import {
  Box,
  makeStyles,
} from '@material-ui/core';
import CollapseBlock from 'components/Shared/CollapseBlock';
import ReportViewTable from '../../Shared/ReportViewTable';
import MarkdownParser from './../widgets/MarkdownParser';
import cx from 'classnames';

const useStyles = makeStyles((theme) => ({
  collapseTabsContainer: {
    position: 'relative',
    marginRight: 66,
    transition: 'margin-right 0.2s linear',
  },
  pinnedNavigation: {
    marginRight: 280,
  },
}));

const ReportContent = ({
                         surveysInfo,
                         refs,
                         updateCurrentBlockId,
                         currentBlockId,
                         setOpenBlock,
                         isNavigationPinned,
                         isComparing,
                       }) => {
  const classes = useStyles();
  return <div
    id={'scrollArea'}
    className={cx(classes.collapseTabsContainer, {
      [classes.pinnedNavigation]: isNavigationPinned,
    })}>
    <Box pl='4px' pt={'16px'}>
      {
        surveysInfo.surveyItems.map(({
                                       title,
                                       surveyItems,
                                       colors = {},
                                       reportContent,
                                       hideAutoGeneratedReportContent,
                                     }) => (
            !!hideAutoGeneratedReportContent === true && !!reportContent
              ? null
              : <CollapseBlock
                refs={refs}
                colors={colors}
                setCurrentBlockId={updateCurrentBlockId}
                title={title}
                currentBlockId={currentBlockId}
                setOpenBlock={setOpenBlock}
                reportContent={reportContent}
              >
                {
                  reportContent && <MarkdownParser content={
                    // Preserve leading spaces in table cells only
                    reportContent.split('\n').map(line => {
                      // Check if this line is a table row (starts with | and ends with |)
                      if (line.trim().startsWith('|') && line.trim().endsWith('|')) {
                        // Split by | to get cells, process each cell
                        const cells = line.split('|');
                        return cells.map((cell, index) => {
                          // Skip first and last empty elements from split
                          if (index === 0 || index === cells.length - 1) return cell;
                          // Replace leading spaces in cell content with non-breaking spaces
                          return cell.replace(/^( +)/, (match) => '\u00A0'.repeat(match.length));
                        }).join('|');
                      }
                      return line;
                    }).join('\n')
                  } />
                }
                {
                  !!hideAutoGeneratedReportContent === true && !reportContent
                    ? null
                    : <ReportViewTable
                      termsAcceptedTimestamp={surveysInfo.termsAcceptedTimestamp}
                      surveyList={surveyItems}
                      counterColoredAnswers={colors}
                      isComparing={isComparing}
                      baseCompletedTimestamp={surveysInfo.baseCompletedTimestamp}
                      currentCompletedTimestamp={surveysInfo.currentCompletedTimestamp}
                    />
                }
              </CollapseBlock>
          ),
        )
      }
    </Box>
  </div>;
};

export default ReportContent;

